import Vue from "vue";
import App from "./App.vue";
import VueRouter from "vue-router";
import routes from "./routes";
import Fragment from "vue-fragment";
import VueMeta from "vue-meta";
import Fullpage from "vue-fullpage.js";
import frag from "vue-frag";
Vue.config.productionTip = false;
Vue.use(Fragment.Plugin);
Vue.use(VueRouter);
Vue.use(VueMeta);
Vue.use(Fullpage);
Vue.directive("frag", frag);

import { EventBus } from "@/events/global-bus.js";

const router = new VueRouter({
    mode: "history",
    routes,
});

router.afterEach(() => {
    EventBus.$emit("rescan-cursor");
});

new Vue({
    render: (h) => h(App),
    router,
}).$mount("#app");
